import { Tooltip } from '@ipfabric/ui-components/Tooltip/Tooltip';
import classNames from 'classnames';
import { Toggle } from 'components/Toggle/Toggle';
import { type FC, memo } from 'react';

interface Props {
  checked: boolean;
  disabled: boolean;
  id: string;
  labelText: string;
  labelTooltipText: string;
  onChange: (checked: boolean) => void;
  wrapperClassName?: string;
}

const BareIsolateInstancesToggle: FC<Props> = (props) => {
  return (
    <div
      className={classNames(
        'flex cursor-pointer items-center',
        props.wrapperClassName,
      )}
    >
      <label htmlFor={props.id} className='mb-0 mr-5'>
        {props.labelText}
        <Tooltip content={props.labelTooltipText}>
          <i className='fa fa-fw fa-question-circle ml-lgu-2' />
        </Tooltip>
      </label>
      <Toggle
        disabled={props.disabled}
        hideStateMessage
        id={props.id}
        onChange={props.onChange}
        value={props.checked}
      />
    </div>
  );
};

export const IsolateInstancesToggle = memo(BareIsolateInstancesToggle);
